module.exports = require("./ne-NP.js");